export const locationTypes = [
  {
    label: 'Warehouse',
    value: 'WAREHOUSE',
  },
  {
    label: 'Plant',
    value: 'PLANT',
  },
];

export const inchargeOptions = [
  {
    label: 'Existing User',
    value: 'existing',
  },
  {
    label: 'Other',
    value: 'other',
  },
];
